import axios from "axios";
import { store } from "../redux/store";

const instance = axios.create({
  baseURL: "http://api.suresearchsoftware.com/api",
});

instance.interceptors.request.use(function (config) {
  const token = store.getState().token;
  config.headers.Authorization = token ? `Bearer ${token}` : "No token";
  // config.headers["Content-Type"] = "multipart/form-data";


  return config;
});

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;
